import {formatPhone} from '@deliveriesondemand/dod-utils';
import {Component} from 'react';
import PropTypes from 'prop-types';

class PhoneInput extends Component {
    static defaultProps = {
        placeholder: 'XXX-XXX-XXXX',
        onChange: () => {}
    };

    static propTypes = {
        placeholder: PropTypes.string,
        onChange: PropTypes.func
    };

    constructor(props) {
        super(props);
        const {value = ''} = props;
        this.state = {value};
    }

    get value() {
        return this.state.value;
    }

    getErrors(label = '') {
        let errs = [];
        const {value} = this.refs.input;
        if (!value) {
            errs.push(`${label} is empty`);
        } else {
            if (!this.isValid()) {
                errs.push(`${label} is invalid`);
            }
        }
        return errs;
    }

    isValid() {
        const {value} = this.refs.input;
        return value.toString().replace(/[-\D+]/g, '').length === 10;
    }

    onChange(e) {
        const value = e.target.value.replace(/\D/g, '');

        if (value.length <= 10) {
            this.props.onChange(value);
            this.setState({value});
        }
    }

    onKeyDown(e) {
        const {keyCode} = e;
        const isNumber = ((keyCode >= 96 && keyCode <= 105) || (keyCode >= 48 && keyCode <= 57));
        const isTAB = keyCode === 9;

        if ((keyCode === 189 || keyCode === 109) && !isTAB && !isNumber) {
            e.preventDefault();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }

    render() {
        return (
            <input
                ref="input"
                type="tel"
                {...this.props}
                onChange={this.onChange.bind(this)}
                onKeyDown={this.onKeyDown.bind(this)}
                value={formatPhone(this.state.value)} />
        );
    }
}

export default PhoneInput;
